// Where "get the mobile app" points. One copy, shared by the /get-app page and the home's
// download-the-app card, so the two can't drift onto different listings.
//
// The mobile app is "Orion by Wix" (App Store id6737450738 / Play com.wix.time). All three links are
// public, verified store handles.

export const IOS_URL = 'https://apps.apple.com/app/id6737450738';
export const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.wix.time';
export const IOS_APP_STORE_ID = '6737450738';

/**
 * The JotURL smart link (config key DOWNLOAD_APP_JOTURL_BASE) device-detects and routes to the right
 * store, and carries deferred deep-linking — so one QR serves iOS, Android, and desktop scanners.
 */
export const APP_SMART_LINK = 'https://invite.mobileappinvite.com/time';
